import PropTypes from "prop-types"
import React, { useContext, useState } from "react"
import Carousel from "react-multi-carousel"
import "react-multi-carousel/lib/styles.css"

import { IntersectionContext } from "@atoms/IntersectionObserver/IntersectionObserver"
import Quote from "@atoms/Quote/Quote"

import styles from "./CarouselTestimonial.module.scss"

const CarouselTestimonial = ({ slides }) => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 1000000, min: 992 },
      items: 1,
      slidesToSlide: 1,
      partialVisibilityGutter: 0,
    },
    tablet: {
      breakpoint: { max: 991, min: 768 },
      items: 1,
      slidesToSlide: 1,
      partialVisibilityGutter: 0,
    },
    mobile: {
      breakpoint: { max: 767, min: 0 },
      items: 1,
      slidesToSlide: 1,
      partialVisibilityGutter: 0,
    },
  }

  const { inView } = useContext(IntersectionContext)

  const [slidingInProgress, setSlidingInProgress] = useState(false)

  const CarouselDot = ({ index, onClick, active }) => {
    return (
      <button
        onClick={(e) => {
          onClick()
          e.preventDefault()
        }}
        className={`${styles.dot} ${active ? styles.active : ""}`}
      >
        {index + 1}
      </button>
    )
  }

  return slides ? (
    <section
      className={`${styles.element} section-break-out make-full-width-on-mobile  make-full-width-on-mobile-with-paddings`}
    >
      <Carousel
        // react-multi-carousel-list
        // react-multi-carousel-track
        infinite={false}
        ssr={true}
        swipeable={slides.length > 1}
        partialVisible={true}
        containerClass={`${styles.carousel} ${
          slidingInProgress ? styles.slidingInProgress : ""
        }`}
        responsive={responsive}
        keyBoardControl
        //renderButtonGroupOutside
        arrows={false}
        showDots={slides.length > 1}
        renderDotsOutside={true}
        customDot={<CarouselDot />}
        dotListClass={styles.dotList}
        minimumTouchDrag={30}
        beforeChange={(nextSlide, { currentSlide, onMove }) => {
          setSlidingInProgress(true)
        }}
        afterChange={(previousSlide, { currentSlide, onMove }) => {
          setSlidingInProgress(false)
        }}
        autoPlay={inView}
        autoPlaySpeed={4000}
      >
        {slides.map((slide, index) => {
          return (
            <div key={index} className="container">
              <div className={styles.item}>
                <Quote
                  html={slide.html}
                  citation={slide.citation}
                  citationStyle="bold"
                />
              </div>
            </div>
          )
        })}
      </Carousel>
    </section>
  ) : (
    ""
  )
}

CarouselTestimonial.propTypes = {
  slides: PropTypes.array,
}

export default CarouselTestimonial
